import "htmx.org";

import ContentCycler from "./ContentCycler";

// Benefit arrow icon toggle
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ch24-benefit-arrow-icon").forEach((icon) => {
    icon.addEventListener("click", () => {
      this.querySelector(".ch24-benefits-text").classList.toggle("hidden");
      this.querySelector(".ch24-benefit-arrow-icon").classList.toggle(
        "rotate-180"
      );
    });
  });
});

// Mobile menu open and close
document.addEventListener("DOMContentLoaded", () => {
  const mainHeader = document.querySelector(".main-header");
  const mainNavigationToggle = document.querySelector(".main-header--toggle");
  const sidebar = document.querySelector(".main-header--navigation");

  function hideMobileNavigation() {
    mainHeader.classList.remove("mainmenu-is-visible");
    sidebar.style.top = "";
  }

  mainNavigationToggle.addEventListener("click", function (event) {
    mainHeader.classList.toggle("mainmenu-is-visible");
    event.stopPropagation();
  });

  document.addEventListener("click", hideMobileNavigation);
  window.addEventListener("resize", hideMobileNavigation);
});

// Dropdown menu functionality for locations
document.addEventListener("DOMContentLoaded", () => {
  const dropdownItems = document.querySelectorAll(".main-menu-item--has-dropdown");

  dropdownItems.forEach(item => {
    const dropdown = item.querySelector(".main-menu-dropdown");
    const link = item.querySelector("a");
    let hoverTimeout;

    if (!dropdown) return;

    // Show dropdown on hover (desktop)
    item.addEventListener("mouseenter", () => {
      clearTimeout(hoverTimeout);
      if (window.innerWidth >= 1454) { // fullmenu breakpoint
        dropdown.style.opacity = "1";
        dropdown.style.visibility = "visible";
        dropdown.style.transform = "translateY(0)";
      }
    });

    // Hide dropdown on mouse leave with delay
    item.addEventListener("mouseleave", () => {
      hoverTimeout = setTimeout(() => {
        if (window.innerWidth >= 1454) {
          dropdown.style.opacity = "0";
          dropdown.style.visibility = "hidden";
          dropdown.style.transform = "translateY(-10px)";
        }
      }, 150);
    });

    // Prevent dropdown from closing when clicking inside it
    dropdown.addEventListener("click", (event) => {
      event.stopPropagation();
    });
  });

  // Handle window resize
  window.addEventListener("resize", () => {
    document.querySelectorAll(".main-menu-dropdown").forEach(dropdown => {
      if (window.innerWidth >= 1454) {
        dropdown.style.display = "";
        dropdown.style.position = "";
        dropdown.style.opacity = "";
        dropdown.style.visibility = "";
        dropdown.style.transform = "";
      }
    });
  });
});

// focus on input when clicking on wrapping div
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ch24-input").forEach((inputWrapper) => {
    inputWrapper.addEventListener("click", () => {
      inputWrapper.querySelector('input[type="text"]').focus();
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-toggleDropdown").forEach((dropdown) => {
    dropdown.addEventListener("click", () => {
      dropdown.querySelector(".arrow-icon").classList.toggle("rotate-180");
      dropdown.parentElement
        .querySelector(".js-toggleDropdown--text")
        .classList.toggle("hidden");
    });
  });
});

window.addEventListener("load", () => {
  document.querySelectorAll(".js-content-cycler").forEach((el) => {
    ContentCycler(el);
  });
});
